/* eslint-disable no-console */
import wrapper from 'wrapper';
import SearchLookup from './components/my-lookup/my-lookup';
import Methodology from './components/methodology/methodology';

wrapper.select('.content-container__enhanced').style.display = 'block';
wrapper.select('.content-container__no-js').style.display = 'none';

const { data } = wrapper.getConfig().app.data;
new SearchLookup(data);
new Methodology();

wrapper.markPageAsLoaded();
